export default __webpack_public_path__ + "static/media/bullet.8123886b.svg";